import axios from "axios"
import store from "../store/store"

/*
토큰이 재발급 되는 동안 다른 요청들은 서버에 보내지 않고 모아 두었다가 새로운 토큰 발급이 완료된 후에 한꺼번에 요청하는 코드를 추가
 */
let isTokenRefreshing = false;
let refreshSubscribers = [];

const onTokenRefreshed = (accessToken) => {
    refreshSubscribers.map((callback) => callback(accessToken));
};

const addRefreshSubscriber = (callback) => {
    refreshSubscribers.push(callback);
};

axios.interceptors.request.use(
    config => {
        const accessToken = store.getters["getAccessToken"];
        const refreshToken = store.getters["getRefreshToken"];
        const isAuthenticated = store.getters["isAuthenticated"]
        if (isAuthenticated) {
            config.headers.common["Authorization"] = store.getters["getAccessToken"]
        }
        return config
    },
    error => {
        // Do something with request error
        return Promise.reject(error)
    }
)

// 응답(response) interceptor
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response.status === 401) {
            const originalRequest = error.config;

            if (!isTokenRefreshing) {
                // isTokenRefreshing이 false인 경우에만 token refresh 요청
                isTokenRefreshing = true;
                const accessToken = store.getters["getAccessToken"];
                const refreshToken = store.getters["getRefreshToken"];
                // token refresh 요청
                const {data} = await axios.post(
                    `/auth/v1/refresh`, // token refresh api
                    {
                        refreshToken: refreshToken,
                    }
                );
                // 새로운 토큰 저장
                const payload = {
                    refreshToken: refreshToken,
                    accessToken: data.accessToken
                }
                store.commit('setToken', payload);

                isTokenRefreshing = false;
                axios.defaults.headers.common["Authorization"] = store.getters["getAccessToken"]
                // 새로운 토큰으로 지연되었던 요청 진행
                onTokenRefreshed(data.accessToken);
                /*
                originalRequest.headers.Authorization = store.getters["getAccessToken"]

                // axios.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
                // originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                // 401로 요청 실패했던 요청 새로운 accessToken으로 재요청
                return axios(originalRequest);
                */
            }
            // token이 재발급 되는 동안의 요청은 refreshSubscribers에 저장
            const retryOriginalRequest = new Promise((resolve) => {
                addRefreshSubscriber((accessToken) => {
                    originalRequest.headers.Authorization = accessToken;
                    resolve(axios(originalRequest));
                });
            });
            return retryOriginalRequest;
        }
        return Promise.reject(error);
    }
)

axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"

export default axios